<template>
    <a-input-group compact>
        <a-select style="width: 20%" v-model="selectedCode">
            <a-select-option
                v-for="i in countryCodes"
                v-bind:value="i.code"
                v-bind:key="i.code"
            >
                {{ i.countryName }}
            </a-select-option>
        </a-select>

        <a-input style="width: 80%" 
                 allow-clear
                 @change="handleOnChangeEvent"
                 v-bind:value="value"
                 v-on:input="$emit('input', $event.target.value)"
                 @blur="handleBlurEvent"
                 @keypress="handleKeyPressEvent"
                 :maxLength="max"

        />
        
    </a-input-group>
</template>

<script>


export default {
    props : ['value'],
    data () {
        return {
            countryCodes : [
                {countryName: 'NO', code: 47}
            ],
            selectedCode : 47,
            max : 8
        }
    },
    methods : {
        handleOnChangeEvent(e) {
         
        },
        handleBlurEvent(e) {
            this.$emit('blur', e);
        },
        handleKeyPressEvent(e) {
            e = (e) ? e : window.event;
            var charCode = (e.which) ? e.which : e.keyCode;
            if((charCode > 31 && charCode < 48 || charCode > 57 && charCode !==46)) {
                e.preventDefault();
            }
            else {
                return false;
            }
        }
    },
    created () {

    }
}

</script>

<style lang="scss" scoped>

</style>